/** Локальная заглушка аватара (без внешних запросов). */
export const DEFAULT_AVATAR_SRC =
  'data:image/svg+xml,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
      '<rect width="100" height="100" fill="#e8eaed"/>' +
      '<circle cx="50" cy="36" r="17" fill="#9aa0a6"/>' +
      '<ellipse cx="50" cy="84" rx="26" ry="20" fill="#9aa0a6"/>' +
    '</svg>'
  );

export function isPlaceholderAvatar(url) {
  if (!url || typeof url !== 'string') return true;
  const value = url.trim().toLowerCase();
  return (
    value === '' ||
    value.includes('placeholder.com') ||
    value.includes('via.placeholder')
  );
}

/** Безопасный onError — сначала другое расширение, затем заглушка. */
export function handleAvatarImgError(event) {
  const img = event.currentTarget;
  const stage = img.dataset.fallbackStage || '0';

  if (stage === '0') {
    const alt = img.dataset.avatarFallback;
    if (alt) {
      img.dataset.fallbackStage = '1';
      img.src = alt;
      return;
    }
  }

  if (stage !== '2') {
    img.dataset.fallbackStage = '2';
    img.onerror = null;
    img.src = DEFAULT_AVATAR_SRC;
  }
}
